import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Select, DatePicker } from 'antd';
import DrawerModal from '../../shared/DrawerModal';
import styles from './AddLicenseModal.styles';
import {
  closeModal,
  getIsVisibleModal,
} from '../../../redux/store/ui/common/index';
import {
  selectSelectedUser,
  addUserDL,
} from '../../../redux/store/userData/users';
import { useIntl } from 'react-intl';
import { zIndex } from '../../../theme/theme';
import { ANT_PICKERS_FORMAT, formatAPIDate } from '../../../utils';
import { selectAdminBrands } from '../../../redux/store/userData/user';

const { Option } = Select;

const AddLicenseModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectSelectedUser);
  const visibleModal = useSelector(getIsVisibleModal('AddLicenseModal'));
  const adminBrands = useSelector(selectAdminBrands);

  const selectedUserBrand = adminBrands?.filter(
    (brand) => brand.id === selectedUser?.brandId
  );

  const supportedLicenseCountries =
    selectedUserBrand[0]?.allowedDrivingLicenseCountries?.map((country) =>
      country.toUpperCase()
    );

  const [number, setNumber] = useState('');
  const [classBValidFrom, setClassBValidFrom] = useState('') as any;
  const [classBValidUntil, setClassBValidUntil] = useState('') as any;
  const [issueDate, setIssueDate] = useState('') as any;
  const [issuingAuthority, setIssuingAuthority] = useState('');
  const [birthPlace, setBirthPlace] = useState('');
  const [issueCountry, setIssueCountry] = useState('DE');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('') as any;

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(
      addUserDL(selectedUser.id, {
        firstName,
        lastName,
        number,
        issueDate: formatAPIDate(issueDate),
        issuingAuthority,
        birthPlace,
        dateOfBirth: formatAPIDate(dateOfBirth),
        issueCountry,
        classBValidFrom: formatAPIDate(classBValidFrom),
        ...(classBValidUntil && {
          classBValidUntil: formatAPIDate(classBValidUntil),
        }),
      })
    );
    dispatch(closeModal('AddLicenseModal'));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('AddLicenseModal'));
  };

  useEffect(() => {
    if (visibleModal) {
      setFirstName('');
      setLastName('');
      setNumber('');
      setBirthPlace('');
      setDateOfBirth('');
      setClassBValidFrom('');
      setIssueDate('');
      setClassBValidUntil('');
      setIssuingAuthority('');
      setIssueCountry('DE');
    }
  }, [visibleModal]);

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('UserContactModal'));
        }}
      >
        <div className="update-phone-modal">
          <div className="phone-modal-wrapper">
            <div className="update-phone-modal-inputs">
              <p
                data-testid="AddLicenseModal-modalTitle"
                className="add-phone-title"
              >
                {intl.formatMessage({
                  id: `fleetadmin.users.info.license.manualForm.title`,
                })}
              </p>
              <div className="license-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.firstName`,
                  })}
                </p>
                <Input
                  data-testid="AddLicenseModal-firstName"
                  value={firstName}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.firstName.placeholder`,
                  })}
                  onChange={(e: any) => {
                    setFirstName(e.target.value);
                  }}
                />
              </div>
              <div className="license-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.lastName`,
                  })}
                </p>
                <Input
                  data-testid="AddLicenseModal-lastName"
                  value={lastName}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.lastName.placeholder`,
                  })}
                  onChange={(e: any) => {
                    setLastName(e.target.value);
                  }}
                />
              </div>
              <div className="license-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.licenseNumber`,
                  })}
                </p>
                <Input
                  data-testid="AddLicenseModal-numberInput"
                  value={number}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.licenseNumber.placeholder`,
                  })}
                  onChange={(e: any) => {
                    setNumber(e.target.value);
                  }}
                />
              </div>
              <div className="license-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.birthPlace`,
                  })}
                </p>
                <Input
                  data-testid="AddLicenseModal-birthPlaceInput"
                  value={birthPlace}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.birthPlace.placeholder`,
                  })}
                  onChange={(e: any) => {
                    setBirthPlace(e.target.value);
                  }}
                />
              </div>
              <div className="license-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.dateOfBirth`,
                  })}
                </p>
                <DatePicker
                  data-testid="AddLicenseModal-dateOfBirth"
                  format={ANT_PICKERS_FORMAT}
                  getPopupContainer={(triggerNode: HTMLElement) => {
                    return triggerNode.parentNode as HTMLElement;
                  }}
                  style={{ width: '100%' }}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.dateOfBirth.placeholder`,
                  })}
                  onChange={(date) => setDateOfBirth(date.toISOString())}
                />
              </div>
              <div className="license-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.license.issuingAuthority.placeholder`,
                  })}
                </p>
                <Input
                  data-testid="AddLicenseModal-issuingAuthorityInput"
                  value={issuingAuthority}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.license.issuingAuthority.placeholder`,
                  })}
                  onChange={(e: any) => {
                    setIssuingAuthority(e.target.value);
                  }}
                />
              </div>
              <div className="license-input">
                <p className="label">
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.issueDate`,
                  })}
                </p>
                <DatePicker
                  data-testid="AddLicenseModal-issueDate"
                  format={ANT_PICKERS_FORMAT}
                  style={{ width: '100%' }}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.issueDate.placeholder`,
                  })}
                  getPopupContainer={(triggerNode: HTMLElement) => {
                    return triggerNode.parentNode as HTMLElement;
                  }}
                  onChange={(date) => setIssueDate(date.toISOString())}
                />
              </div>
              <div className="license-input">
                <p
                  data-testid="AddLicenseModal-issueDateClassBLabel"
                  className="label"
                >
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.classB.From`,
                  })}
                </p>
                <DatePicker
                  data-testid="AddLicenseModal-issueDateClassB"
                  format={ANT_PICKERS_FORMAT}
                  getPopupContainer={(triggerNode: HTMLElement) => {
                    return triggerNode.parentNode as HTMLElement;
                  }}
                  style={{ width: '100%' }}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.classB.From.placeholder`,
                  })}
                  onChange={(date) => setClassBValidFrom(date.toISOString())}
                />
              </div>
              <div className="license-input">
                <p
                  data-testid="AddLicenseModal-expairyDateClassBLabel"
                  className="label"
                >
                  {intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.classB.until`,
                  })}
                </p>
                <DatePicker
                  data-testid="AddLicenseModal-expiryDateClassB"
                  format={ANT_PICKERS_FORMAT}
                  getPopupContainer={(triggerNode: HTMLElement) => {
                    return triggerNode.parentNode as HTMLElement;
                  }}
                  style={{ width: '100%' }}
                  placeholder={intl.formatMessage({
                    id: `fleetadmin.users.info.license.manualForm.classB.until.placeholder`,
                  })}
                  onChange={(date) => setClassBValidUntil(date.toISOString())}
                />
              </div>
              <p className="label">
                {intl.formatMessage({
                  id: `fleetadmin.users.info.license.manualForm.issueCountry`,
                })}
              </p>
              <Select
                data-testid="AddLicenseModal-issueCountry"
                dropdownStyle={{ zIndex: zIndex.dropDown }}
                value={issueCountry}
                style={{ width: '100%' }}
                placeholder={intl.formatMessage({
                  id: `fleetadmin.users.info.id.manualForm.issueCountry`,
                })}
                onChange={(code: string) => setIssueCountry(code)}
              >
                {supportedLicenseCountries?.map((country) => (
                  <Option
                    data-testid={`AddLicenseModal-issueCountryOption-${country}`}
                    key={country}
                    value={country}
                  >
                    {intl.formatMessage({
                      id: `${country}`,
                    })}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <Button
            data-testid="AddLicenseModal-updatedDLData"
            disabled={!(number && issueCountry && issueDate && classBValidFrom)}
            className="submit-button"
            onClick={handleOnSubmit}
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default AddLicenseModal;
